import { render, staticRenderFns } from "./LandingPageSettings.vue?vue&type=template&id=0a57b228&lang=pug&"
import script from "./LandingPageSettings.vue?vue&type=script&lang=js&"
export * from "./LandingPageSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports